import axios from "axios";
import router from "@/router/index";
import store from "../state/store";

export default class AxiosBase {
  constructor() {
    axios.interceptors.response.use(
      (response) => response,
      function (error) {
        if (error && error.response.status === 401) {
          const backendBaseUrl = process.env.VUE_APP_BACKEND_URL;
          window.location.replace(
            `${backendBaseUrl}/api/Identity/Auth/Login?returnUrl=${backendBaseUrl}/api/Identity/Auth/AssertionConsumerService`
          );
        } else if (error && error.response.status === 403) {
          router.push({
            path: "/error-403",
          });
          //  window.location.replace('error-403');
        }
        return Promise.reject(error);
      }
    );

    axios.interceptors.request.use(function (config) {
      let token = localStorage.getItem("token");

      let language = localStorage.getItem("language");
      if (!language) {
        language = "tr";
      }
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["Content-Type"] = "application/json";
      config.headers["Referrer"] = router.currentRoute.fullPath;
      config.headers["Accept-Language"] = language;
      if (!config.url.includes("GenerateRefreshToken")) {
        store.commit("layout/resetCounter");
      } else {
        store.commit("layout/resetToken");
      }

      return config;
    });
  }
}
